<div class="d-flex flex-column">
  <div class="page-background">
    <app-page-header-public-alt [isLanding]="isLanding" [isTopBannerVisible]="isTopBannerVisible"/>
    <div class="position-relative page-content" [style.min-height]="contentHeight">
      <ng-content></ng-content>
    </div>
  </div>
</div>

@if (showFooter) {
  <app-footer [displayLargeMobileFooter]="displayLargeMobileFooter"/>
}
